var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"color-model__pure"},[_c('color-picker',{on:{"input":_vm.onInput},model:{value:(_vm.color),callback:function ($$v) {_vm.color=$$v},expression:"color"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }